$(function () {
	const SPEED    = 0.15;   // 0 = no movement, 0.5 = strong effect
	const BLEED_VH = 35;    // extra vh above and below — keep >= SPEED * 60
	const REVERSE  = true;  // true = image moves opposite to scroll direction
	const EASE     = 0.2;  // fraction to close per frame — lower = smoother/lazier

	let items = [];

	function collect() {
		items = [];
		$('.js-parallax').each(function () {
			const $bg = $(this).find('.dynamic-visuals__parallax-bg');
			if (!$bg.length) return;
			$bg.css({
				height:    (100 + BLEED_VH * 2) + 'vh',
				marginTop: '-' + BLEED_VH + 'vh'
			});
			items.push({ $container: $(this), $bg: $bg, current: 0 });
		});
	}

	function update() {
		const wh        = $(window).height();
		const maxOffset = wh * (BLEED_VH / 100);
		const direction = REVERSE ? -1 : 1;

		$.each(items, function (i, item) {
			const rect       = item.$container[0].getBoundingClientRect();
			const fromCenter = (rect.top + rect.height / 2) - wh / 2;
			const target     = Math.max(-maxOffset, Math.min(maxOffset, fromCenter * SPEED * direction));
			item.current    += (target - item.current) * EASE;
			item.$bg.css('transform', 'translateY(' + item.current + 'px)');
		});

		requestAnimationFrame(update);
	}

	collect();
	requestAnimationFrame(update);
});
